import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home'
import NotFound from '@/components/NotFound'
import Calendar from '@/components/Calendar'
import Documents from '@/components/Documents'
import Notifications from '@/components/Notifications'
import Newsletter from '@/components/Newsletter'
import Login from '@/components/Login'
import Users from '@/components/Users'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    name: 'home',
    path: '/home',
    component: Home
  },
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'usuarios',
    path: '/usuarios',
    component: Users
  },
  {
    name: 'calendario',
    path: '/calendario',
    component: Calendar
  },
  {
    name: 'documentos',
    path: '/documentos',
    component: Documents
  },
  {
    name: 'notificaciones',
    path: '/notificaciones',
    component: Notifications
  },
  {
    name: 'newsletter',
    path: '/newsletter',
    component: Newsletter
  },
  {
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({routes, mode: 'history'})

// router.beforeEach((to, from, next) => {
//   const authUser = JSON.parse(window.localStorage.getItem('token'))
//   if (to.meta.requiresAuth) {
//     if (!authUser || !authUser.data.token) {
//       next({name: 'login'})
//     } else if (to.meta.adminAuth) {
//       // const authUser = JSON.parse(window.localStorage.getItem('token'))
//       // if(authUser.data.role_id === 'ADMIN') {
//       //   next()
//       // }else {
//       //   next('/resident')
//       // }
//       next()
//     }
//   // else if(to.meta.residentAuth) {
//   //   const authUser = JSON.parse(window.localStorage.getItem('token'))
//   //   if(authUser.data.role_id === 'RESIDENT') {
//   //     next()
//   //   }else {
//   //     console.log('Im in admin')
//   //     next('/admin')
//   //   }
//   // }
//   } else {
//     next()
//   }
// })

export default router
